// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityCopay {
    static getAttributeTypeMap() {
        return MedicalEligibilityCopay.attributeTypeMap;
    }
}
MedicalEligibilityCopay.discriminator = undefined;
MedicalEligibilityCopay.additionalProperties = false;
MedicalEligibilityCopay.attributeTypeMap = [
    {
        "name": "appliesToOop",
        "baseName": "appliesToOop",
        "type": "string"
    },
    {
        "name": "waivedAfterOop",
        "baseName": "waivedAfterOop",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityCopay.js.map